module.exports = __webpack_public_path__ + "static/img/classdetail_class_detail_intro.b4a33e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classdetail_class_detail_intro.png
// module id = a6qQ
// module chunks = 0